<template>
  <div>
    <a
      href="#"
      class="btn btn-icon btn-clean btn-lg w-40px h-40px text-hover-primary"
      id="kt_quick_user_toggle"
      data-toggle="tooltip"
      data-placement="right"
      data-container="body"
      data-boundary="window"
      title=""
      data-original-title="Profil Pengguna"
    >
      <span class="symbol symbol-30 symbol-lg-40">
        <span class="svg-icon svg-icon-xl svg-icon-white">
          <i class="fas fa-user text-white"></i>
        </span>
      </span>
    </a>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-left p-8"
    >
      <!--begin::Header-->
      <div
        class="offcanvas-header d-flex align-items-center justify-content-between pb-5 border-bottom border-light"
      >
        <h3 class="font-weight-bold m-0 user-profile-title">
          User Profile
        </h3>
        <a
          href="#"
          class="btn btn-xs btn-icon btn-light btn-close-custom"
          id="kt_quick_user_close"
        >
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content pr-5 mr-n5 scroll mt-6"
        style="max-height: 90vh; position: relative"
      >
        <!--begin::Header-->
        <div class="d-flex align-items-center mt-5">
          <div class="symbol symbol-100 mr-5 user-avatar-container">
            <img class="symbol-label" :src="'/img/default/default-user.svg'" alt="" />
            <i class="symbol-badge bg-success"></i>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <a
              href="#"
              class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary user-display-name"
            >
              {{ (currentUser && currentUser.name) || "Administrator" }}
            </a>
            <div class="text-muted mt-1 user-display-role">{{ (currentUser && currentUser.role_name) || "Medhop SaaS" }}</div>
            <div class="navi mt-3" v-if="currentUser && currentUser.email">
              <a href="#" class="navi-item">
                <span class="navi-link p-0 pb-3">
                  <span class="navi-icon mr-2">
                    <span class="svg-icon svg-icon-lg">
                      <inline-svg
                        :src="base_url + 'media/svg/icons/Communication/Mail-notification.svg'"
                      />
                    </span>
                  </span>
                  <span class="navi-text text-muted text-hover-primary user-display-email">
                    {{ currentUser.email }}
                  </span>
                </span>
              </a>
            </div>
            <button class="btn btn-logout-custom" @click="onLogout">
              Sign out
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="separator separator-dashed mt-8 mb-5"></div>
        <div class="navi navi-spacer-x-0 p-0"></div>
        <div class="separator separator-dashed my-7"></div>
        <div>
          <template v-for="(item, i) in list">
            <!--begin::Item -->
            <div
              class="d-flex align-items-center rounded p-5 gutter-b"
              v-bind:class="`bg-light-${item.type}`"
              v-bind:key="i"
              @click="showModal(item.id)"
            >
              <span
                class="svg-icon mr-5"
                v-bind:class="`svg-icon-${item.type}`"
              >
                <span class="svg-icon svg-icon-lg">
                  <inline-svg src="/media/svg/icons/Code/Info-circle.svg" />
                </span>
              </span>
              <div class="d-flex flex-column flex-grow-1 mr-2">
                <a
                  href="#"
                  class="font-weight-normal text-dark-75 text-hover-primary font-size-lg mb-1"
                >
                  {{ item.title }}
                </a>
                <span class="text-muted font-size-sm">
                  {{ item.content.length > 30 ? item.content.substr(0, 30) + '...' : item.content }}
                </span>
              </div>
            </div>
            <!--end::Item -->
          </template>
        </div>
      </perfect-scrollbar>
      <!--end::Content-->
    </div>

    <!--Start::Modal Announcement -->
    <b-modal ref="modal-announcement-show" size="lg" hide-footer :title="detailAnnouncement.title">
      <div class="d-block text-center">
        <img v-if="detailAnnouncement.image" :src="detailAnnouncement.image" width="400" class="mb-10">
        <div class="mt-10" v-html="detailAnnouncement.content"></div>
      </div>
    </b-modal>
    <!--End::Modal Announcement -->
  </div>
</template>

<script>
import { LOGOUT } from "@/core/services/store/auth.module";
import { mapGetters } from 'vuex'
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";
import ApiService from "@/core/services/api.service.js";
import Swal from "sweetalert2";
import { destroyToken, destroyUser, destroyAccess } from "@/core/services/jwt.service.js";
import { getUser, setUser } from "@/core/services/jwt.service.js";
import module from "@/core/modules/CrudModule.js";

export default {
  name: "KTQuickUser",
  data() {
    return {
      DataUser: {},
      currentUser: {},
      roles: {},
      base_url: process.env.BASE_URL,
      list: [],
      detailAnnouncement: {}
    };
  },
  methods: {
    async get() {
      const user = getUser();
      if (user && user.id) {
        try {
          const res = await module.get('users/' + user.id);
          if (res) this.currentUser = res;
        } catch (e) {}
      }
    },
    onLogout() {
      const user = getUser();
      const logoutAction = () => {
        this.$root.$emit('stopTimeLog');
        this.$store.dispatch(LOGOUT).then(() => {
          this.$router.push({ name: "login" }).catch(() => {});
          destroyToken();
          destroyUser();
          window.localStorage.removeItem("RefreshToken");
          window.localStorage.removeItem("access_right_display");
          window.localStorage.removeItem("access_right");
        });
      };
      if (user && user.id) {
        ApiService.put(`users/${user.id}/set-user-off`)
          .then(() => logoutAction())
          .catch(() => logoutAction());
      } else {
        logoutAction();
      }
    },
    closeOffcanvas() {
      this.$root.$emit('openActivityUser')
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },
    closeOffcanvasMessage() {
      this.$root.$emit('openChatAside')
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },

    async getAnnouncement() {
      let filterParams = ``;
      let response = await module.paginate(
        "api/announcements/get-shows"
      );

      for (let a = 0; a < response.data.length; a++) {
        let number = Math.random()
        response.data[a].type = 'warning';
        if(number < 0.34){
          response.data[a].type = 'info';
        }else if(number >= 0.34 && number < 0.67){
          response.data[a].type = 'primary';
        }else{
          response.data[a].type = 'success';
        }
      }

      this.list = response.data;
    },
    async showModal(id) {
      this.detailAnnouncement = await module.get('api/announcements/' + id)
      this.$refs['modal-announcement-show'].show()
    },
  },
  mounted() {
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
    this.get()

    this.$root.$on("refreshCurrentUser", () => {
      this.get()
    });
  },
  computed: {
    picture() {
      return process.env.BASE_URL + "media/users/300_21.jpg";
    },
    ...mapGetters(["currentUserPersonalInfo"])
  },
};
</script>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
  font-family: "Poppins", "Inter", sans-serif;
  background-color: #ffffff;
  border-right: 1px solid #edf2f7;
  box-shadow: 10px 0 40px rgba(0, 0, 0, 0.06);
}

.user-profile-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.btn-close-custom {
  background-color: #f1f5f9 !important;
  border-radius: 50% !important;
  width: 28px !important;
  height: 28px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none !important;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e2e8f0 !important;
  }
}

.user-avatar-container {
  border-radius: 20px !important;
  overflow: hidden;
  border: 3px solid #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  
  .symbol-label {
    background-color: #f8fafc;
  }
}

.user-display-name {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b !important;
}

.user-display-role {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #94a3b8 !important;
  letter-spacing: 0.05em;
}

.user-display-email {
  font-size: 12px;
  color: #64748b !important;
}

.navi-icon {
  svg {
    fill: #94a3b8 !important;
    color: #94a3b8 !important;
    width: 16px;
    height: 16px;
  }
}

.btn-logout-custom {
  background-color: rgba(239, 68, 68, 0.08) !important;
  color: #ef4444 !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 8px 16px !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  margin-top: 12px;
  width: 100px;
  text-align: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: #ef4444 !important;
    color: #ffffff !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(239, 68, 68, 0.15) !important;
  }
}
</style>
